import { useEffect } from 'react';

/**
 * Buy Me A Coffee floating widget component
 * 
 * The official BMC widget script listens for DOMContentLoaded, which has
 * already fired by the time React mounts components. We manually create
 * the widget elements that the script would normally create.
 */
export function BuyMeACoffeeButton() {
  useEffect(() => {
    // Config matching your widget settings
    const config = {
      id: 'mythicforge',
      description: 'Support me on Buy me a coffee!',
      message: 'Thanks for checking out MythicForge. The gates are open for free, but a little treasure tossed in the coffer never goes amiss.',
      color: '#d4a85a',
      position: 'Right',
      x_margin: 18,
      y_margin: 18,
    };

    // Check if widget already exists
    if (document.getElementById('bmc-wbtn')) {
      return;
    }

    const windowHeight = window.innerHeight - 120;

    // Create the floating button
    const btn = document.createElement('div');
    btn.id = 'bmc-wbtn';
    btn.style.cssText = `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
      background: linear-gradient(180deg, #e8c06a 0%, #d4a85a 50%, #a8823e 100%);
      color: #1a1a2e;
      border-radius: 32px;
      position: fixed;
      ${config.position === 'left' ? 'left' : 'right'}: ${config.x_margin}px;
      bottom: ${config.y_margin}px;
      border: 2px solid rgba(232, 192, 106, 0.6);
      box-shadow: 
        inset 0 1px 0 rgba(255, 255, 255, 0.3),
        0 4px 12px rgba(0, 0, 0, 0.4),
        0 0 15px rgba(212, 168, 90, 0.25);
      z-index: 9999;
      cursor: pointer;
      font-weight: 600;
      transition: .25s ease all;
    `;
    btn.innerHTML = '<img src="https://cdn.buymeacoffee.com/widget/assets/coffee%20cup.svg" alt="Buy Me a Coffee" style="height: 36px; width: 36px; margin: 0; padding: 0;">';

    // Create the overlay container
    const overlay = document.createElement('div');
    overlay.id = 'bmc-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 0;
      height: 0;
      background: rgba(0, 0, 0, 0);
      text-align: center;
      z-index: 9999999;
    `;

    // Create the iframe
    const iframe = document.createElement('iframe');
    iframe.id = 'bmc-iframe';
    iframe.setAttribute('allow', 'publickey-credentials-get *; payment *');
    iframe.title = 'Buy Me a Coffee';
    iframe.style.cssText = `
      position: fixed;
      margin: 0;
      border: 0;
      ${config.position === 'left' ? 'left' : 'right'}: ${config.x_margin}px;
      bottom: ${config.y_margin + 72}px;
      height: 0;
      opacity: 0;
      width: 420px;
      max-width: 420px;
      min-height: ${windowHeight}px;
      max-height: ${windowHeight}px;
      border-radius: 10px;
      box-shadow: -6px 0px 30px rgba(13, 12, 34, 0.1);
      background: #fff url(https://cdn.buymeacoffee.com/assets/img/widget/loader.svg) center / 64px no-repeat;
      z-index: 999999;
      transition: all .25s ease;
      transform-origin: right bottom;
      transform: scale(0);
      user-select: none;
    `;

    overlay.appendChild(iframe);
    document.body.appendChild(overlay);
    document.body.appendChild(btn);

    let loaded = false;

    // Button click handler
    btn.onclick = () => {
      if (!loaded) {
        iframe.src = `https://www.buymeacoffee.com/widget/page/${config.id}?description=${encodeURIComponent(config.description)}&color=${encodeURIComponent(config.color)}`;
        loaded = true;
      }
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      iframe.style.height = `${window.innerHeight - 120}px`;
      iframe.style.transform = 'scale(1)';
      iframe.style.opacity = '1';
      btn.innerHTML = '<svg style="width: 16px;height:16px;" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1133 0L8 6.11331L1.88669 0L0 1.88663L8 9.88663L16 1.88663L14.1133 0Z" fill="#1a1a2e"/></svg>';
    };

    btn.onmouseover = () => {
      btn.style.background = 'linear-gradient(180deg, #f0d080 0%, #e8c06a 50%, #d4a85a 100%)';
      btn.style.boxShadow = 'inset 0 1px 0 rgba(255, 255, 255, 0.4), 0 6px 20px rgba(0, 0, 0, 0.5), 0 0 25px rgba(212, 168, 90, 0.35)';
      btn.style.transform = 'translateY(-2px) scale(1.1)';
    };

    btn.onmouseleave = () => {
      btn.style.background = 'linear-gradient(180deg, #e8c06a 0%, #d4a85a 50%, #a8823e 100%)';
      btn.style.boxShadow = 'inset 0 1px 0 rgba(255, 255, 255, 0.3), 0 4px 12px rgba(0, 0, 0, 0.4), 0 0 15px rgba(212, 168, 90, 0.25)';
      btn.style.transform = 'scale(1)';
    };

    // Overlay click to close
    overlay.onclick = () => {
      overlay.style.width = '0';
      overlay.style.height = '0';
      iframe.style.height = '0';
      iframe.style.opacity = '0';
      iframe.style.transform = 'scale(0)';
      btn.innerHTML = '<img src="https://cdn.buymeacoffee.com/widget/assets/coffee%20cup.svg" alt="Buy Me a Coffee" style="height: 36px; width: 36px; margin: 0; padding: 0;">';
    };

    // Cleanup on unmount
    return () => {
      btn.remove();
      overlay.remove();
    };
  }, []);

  return null;
}
